import { motion, useReducedMotion } from 'framer-motion';

import pt from '../../locales/pt';
import { LANDING_EASE } from './ScrollReveal';

/**
 * Illustrative hero device — hero/phone-mock in Landing .pen.
 */
export function HeroDeviceMock() {
  const device = pt.landing.hero.device;
  const reduceMotion = useReducedMotion();

  return (
    <motion.div
      className="mx-auto w-[260px] mid:w-[280px] wide:w-[300px]"
      data-testid="hero-device-mock"
      initial={reduceMotion ? false : { opacity: 0, y: 32 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.65, delay: 0.24, ease: LANDING_EASE }}
    >
      <motion.div
        className="rounded-ds-xl border border-border bg-card p-space-5 shadow-[0_28px_56px_-24px_rgba(74,98,67,0.45)]"
        animate={reduceMotion ? undefined : { y: [0, -6, 0] }}
        transition={
          reduceMotion
            ? undefined
            : { duration: 5.5, repeat: Infinity, ease: 'easeInOut', delay: 0.9 }
        }
      >
        <div className="flex items-center justify-between">
          <p className="font-display text-type-title-card font-bold text-foreground">
            {device.greeting}
          </p>
          <span className="flex h-7 w-7 items-center justify-center rounded-ds-full bg-sage-100 text-type-chip font-bold text-sage-800 dark:bg-sage-900/60 dark:text-sage-200">
            {device.avatarInitial}
          </span>
        </div>

        <p className="type-section mt-space-4 text-sage-700 dark:text-sage-300">
          {device.cycleLabel}
        </p>

        <div className="mt-space-3 rounded-ds-lg bg-gradient-to-br from-sage-500 to-sage-700 p-space-4 text-sage-50">
          <p className="type-section text-sage-100">{device.netWorthLabel}</p>
          <p className="type-display-kpi mt-space-1 text-sage-50">{device.netWorthValue}</p>
        </div>

        <div className="mt-space-3 grid grid-cols-2 gap-space-2">
          <div className="rounded-ds-md border border-border bg-muted/60 p-space-3">
            <p className="type-caption text-muted-foreground">{device.remainingLabel}</p>
            <p className="type-display-stat mt-space-1 text-sage-800 dark:text-sage-200">
              {device.remainingValue}
            </p>
          </div>
          <div className="rounded-ds-md border border-border bg-muted/60 p-space-3">
            <p className="type-caption text-muted-foreground">{device.savingsLabel}</p>
            <p className="type-display-stat mt-space-1 text-foreground">{device.savingsValue}</p>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
}
